// @ts-nocheck
// Store Custom Component
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import { linkStyles } from "@store/Themes/common/mixins/link";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    variant?: string;
    extendedStyles?: SignInForYourPriceStyles;
    overridedStyles?: SignInForYourPriceStyles;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const { userName } = state.context.session;
    const currentUserIsGuest = getCurrentUserIsGuest(state);

    return {
        isSignedIn: userName && !currentUserIsGuest,
        pageType: getCurrentPage(state).type,
        currentLocation: getLocation(state),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

interface SignInForYourPriceStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
    button?: ButtonPresentationProps;
}

export const signInForYourPriceStyles: SignInForYourPriceStyles = {
    wrapper: {
        css: css`
            ${spacingStyles(pxToRem(10), null)}
        `,
    },
    link: {
        css: css`
            ${linkStyles("accent.main", "accent.dark", false, true)}
            font-size: ${x => x.theme.design.typography.size.smallest};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    button: {
        sizeVariant: "small",
        variant: "secondary",
    },
};

const SignInForYourPrice = ({
    variant,
    isSignedIn,
    pageType,
    extendedStyles,
    overridedStyles,
    currentLocation,
    history,
    signInUrl,
}: Props) => {
    if (isSignedIn) {
        return null;
    }

    const styles = useExpandProps(signInForYourPriceStyles, extendedStyles, overridedStyles);

    const onSignInHandler = (e: React.MouseEvent) => {
        if (!signInUrl) {
            logger.warn("No url was found for SignInPage, defaulting to /SignIn");
            history.push("/MyAccount/SignIn");
        } else {
            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${signInUrl}`);
            } else {
                history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
            }
        }
        e.preventDefault();
    };

    const LinkVariant = () => {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Link onClick={onSignInHandler} {...styles.link}>
                    {translate("Sign In for your Price")}
                </Link>
            </StyledWrapper>
        );
    };

    const ButtonVariant = () => {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Button onClick={onSignInHandler} {...styles.button}>
                    {translate("Sign In for your Price")}
                </Button>
            </StyledWrapper>
        );
    };

    if (variant === "link") {
        return <LinkVariant />;
    }

    return <ButtonVariant />;
};

export default connect(mapStateToProps)(withHistory(SignInForYourPrice));
